// Copyright (c) Jupyter Development Team.
// Distributed under the terms of the Modified BSD License.
import { Token } from '@lumino/coreutils';
/**
 * The Logger Registry token.
 */
export const ILoggerRegistry = new Token('@jupyterlab/logconsole:ILoggerRegistry', 'A service providing a logger infrastructure.');
//# sourceMappingURL=tokens.js.map